import {LayoutEditableField} from "../components/FieldsLayoutEditor";
import {
  AVAILABLE_WIDTH_MAP,
  DISABLED_FIELDS_MESSAGE_MAP,
  FIXED_WIDTH_FIELDS_MAP,
  SEPARATOR_WIDTH
} from "../constants/constants";
import {CardTypeV2} from "../constants/enums";

export const getAvailableWidth = (cardType: CardTypeV2, numberOfSeparators: number): number => {
  return Math.max(
    AVAILABLE_WIDTH_MAP[cardType] - (numberOfSeparators > 0 ? numberOfSeparators : 0) * SEPARATOR_WIDTH,
    0
  );
};

export const isValidLayoutEditableField = (fields: LayoutEditableField[], cardType: CardTypeV2): boolean => {
  if (fields.length === 0) return true;
  const numberOfSeparators = fields.length - 1;
  const totalWidth = fields.reduce((sum, field) => sum + field.width, 0);
  return totalWidth === getAvailableWidth(cardType, numberOfSeparators);
};

export const createLayoutEditableFields = (fields: string[], cardType: CardTypeV2): LayoutEditableField[] => {
  if (fields.length === 0) {
    return [];
  }
  const numberOfSeparators = fields.length - 1;

  if (numberOfSeparators === 0) {
    if (FIXED_WIDTH_FIELDS_MAP.has(fields[0])) {
      const fixedWidth = FIXED_WIDTH_FIELDS_MAP.get(fields[0])!;
      return [
        {
          field: fields[0],
          width: fixedWidth,
          isDisabled: true,
          hoverContent: DISABLED_FIELDS_MESSAGE_MAP.get(fields[0])
        }
      ];
    }
    return [{field: fields[0], width: getAvailableWidth(cardType, 0), isDisabled: true, hoverContent: ""}];
  } else {
    if (fields.some((field) => FIXED_WIDTH_FIELDS_MAP.has(field))) {
      const calculatingFields = fields.map((field) => {
        if (FIXED_WIDTH_FIELDS_MAP.has(field)) {
          const fixedWidth = FIXED_WIDTH_FIELDS_MAP.get(field)!;
          return {
            field,
            width: fixedWidth,
            isDisabled: true,
            hoverContent: DISABLED_FIELDS_MESSAGE_MAP.get(field)
          };
        }
        return {field, width: 0, isDisabled: false, hoverContent: ""};
      });
      const totalFixedWidth = calculatingFields.reduce((sum, field) => sum + field.width, 0);
      const availableWidth = getAvailableWidth(cardType, numberOfSeparators) - totalFixedWidth;
      const widthPerField = availableWidth / (fields.length - calculatingFields.filter((f) => f.isDisabled).length);
      return calculatingFields.map((field) => {
        if (field.isDisabled) {
          return field;
        }
        return {
          ...field,
          width: widthPerField,
          isDisabled: true,
          hoverContent: ""
        };
      });
    } else {
      const widthPerField = getAvailableWidth(cardType, numberOfSeparators) / fields.length;
      return fields.map((field) => ({
        field,
        width: widthPerField,
        isDisabled: false,
        hoverContent: ""
      }));
    }
  }
};
